var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg082Star(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9999 8L15.6699 8.05L12.9199 1.61C12.7634 1.2405 12.4012 1.00033 11.9999 1C11.5987 1.00033 11.2364 1.2405 11.0799 1.61L8.33993 8H1.99993C1.5789 8.00018 1.20308 8.26405 1.05993 8.66C0.91595 9.05625 1.03595 9.50023 1.35993 9.77L6.78993 14.29L4.07993 20.61C3.90988 21.0043 4.0105 21.4631 4.32993 21.75C4.6527 22.0394 5.12515 22.0878 5.49993 21.87L11.9999 18.15L18.4999 21.87C18.6523 21.9564 18.8248 22.0012 18.9999 22C19.2464 22.0021 19.4851 21.9131 19.6699 21.75C19.9894 21.4631 20.09 21.0043 19.9199 20.61L17.2099 14.29L22.6399 9.77C22.9639 9.50023 23.0839 9.05625 22.9399 8.66C22.7833 8.2746 22.4156 8.01647 21.9999 8ZM15.3699 13.23C15.0308 13.5125 14.9171 13.9839 15.0899 14.39L16.9199 18.65L12.4999 16.13C12.1905 15.9514 11.8093 15.9514 11.4999 16.13L7.08993 18.65L8.91993 14.39C9.09281 13.9839 8.97903 13.5125 8.63993 13.23L4.75993 10H8.99993C9.40121 9.99967 9.76343 9.75951 9.91993 9.39L11.9999 4.54L14.0799 9.44C14.2364 9.80951 14.5987 10.0497 14.9999 10.05H19.1999L15.3699 13.23Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg082Star);
export default __webpack_public_path__ + "static/media/082-star.982c05c4f28ac973a44dccb736ac609d.svg";
export { ForwardRef as ReactComponent };